var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Datapath {
    constructor() {
        this.videoWalls = [];
        // Index the layouts by the port number of the video wall.
        this.layouts = {};
        this.currentLayout = {};
        this.asyncHandlers = [
            {
                name: 'layoutGetAll',
                path: /:(\d+)\/api\/v1\/layouts$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] in this.layouts) {
                        return { data: this.layouts[match[1]] };
                    }
                    return { data: '' };
                }),
            },
            {
                name: 'layoutGetCurrent',
                path: /:(\d+)\/api\/v1\/layouts\/current$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] in this.currentLayout) {
                        const layoutId = this.currentLayout[match[1]];
                        const myLayouts = this.layouts[match[1]];
                        for (const layout of myLayouts) {
                            if (layout.layoutId === layoutId) {
                                return { data: layout };
                            }
                        }
                    }
                    return {
                        data: {
                            layoutId: '00000000-0000-0000-0000-000000000000',
                            layoutName: null,
                            isDirty: false,
                            isLocalLayout: false,
                            clientWallInstanceId: '00000000-0000-0000-0000-000000000000',
                            templateInformation: {
                                rows: 0,
                                columns: 0,
                                cells: [],
                            },
                        },
                    };
                }),
            },
            {
                name: 'layoutSet',
                path: /:(\d+)\/api\/v1\/layouts\/(.+)\/open$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] in this.layouts) {
                        this.currentLayout[match[1]] = match[2];
                        return {
                            headers: {
                                'content-length': '0',
                                server: 'Microsoft-HTTPAPI/2.0',
                                'application-version': '1.12.8',
                                date: new Date().toISOString(),
                                connection: 'close',
                            },
                            status: 200,
                        };
                    }
                    return {
                        data: {
                            title: 'Layout does not exist',
                            status: 404,
                            detail: `A layout with ID ${match[2]} does not exist`,
                            SystemNotificationSent: false,
                        },
                    };
                }),
            },
            {
                name: 'oemInfo',
                path: /:\d+\/api\/v1\/Server\/oem$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: 'Datapath' };
                }),
            },
            {
                name: 'serverInfo',
                path: /:\d+\/api\/v1\/Server\/information$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: this.serverInfo };
                }),
            },
            {
                name: 'wallGetAll',
                path: /:\d+\/api\/v1\/Walls$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: this.videoWalls };
                }),
            },
        ];
        // Used fixed wall and layout id's for the emulator
        const wallInfo = [
            {
                // First wall has known wallId, port, and name.
                wallId: '11111111-1111-1111-1111-111111111111',
                wallPort: 8081,
                wallName: 'Blueprint',
                layoutIds: [
                    'cb171d7a-4fa5-74ca-4c1c-fae0bb4386a2',
                    'a58f3180-f4d4-1971-af0d-08f6350acc78',
                    '812897cf-5312-584e-21cb-5dc9741b6024',
                ],
            },
            {
                wallId: 'c83da5fd-1501-a272-c540-1c3e7640c1bd',
                wallPort: 33333,
                wallName: 'Wall 2',
                layoutIds: [
                    '74a16268-52e8-1dc0-ee8a-125519b2db9b',
                    'dd0fb5e3-dc07-ff12-47cc-bce1a0842f2c',
                    '1b0cacfd-89e1-d337-91cc-67e7d7b636d3',
                ],
            },
            {
                wallId: '76ce6aa1-0c86-d54e-5837-9a2a2a792595',
                wallPort: 34444,
                wallName: 'Wall 3',
                layoutIds: [
                    'd581c4af-435e-9a50-7273-92d2dde25ab9',
                    '95547608-281f-26ba-8c6f-405aadabc432',
                    'a0f6a947-03e4-0ad4-1e7c-29c0a3b0efb2',
                ],
            },
        ];
        let i = 1;
        for (const wall of wallInfo) {
            this.videoWalls.push(this.createVideoWall(wall));
            // For each video wall, create three layouts.
            const localLayouts = [];
            const layoutIds = wall.layoutIds;
            for (let j = 0; j < layoutIds.length; j++) {
                localLayouts.push(this.createLayout(layoutIds[j], `Layout ${i}:${j + 1}`));
            }
            this.layouts[wall.wallPort] = localLayouts;
            // Initialize current layout to the first layout for each video wall.
            this.currentLayout[wall.wallPort] = localLayouts[0].layoutId;
            i++;
        }
        this.serverInfo = this.createServerInfo();
    }
    createVideoWall(wallInfo) {
        const wallData = {
            wallId: wallInfo.wallId,
            wallName: wallInfo.wallName,
            wallPort: wallInfo.wallPort,
            cliPort: wallInfo.wallPort,
            collaborationPort: wallInfo.wallPort + 1,
            autoStart: true,
            showInWebUi: true,
            isPartition: false,
            displayGroup: {
                id: this.makeId(),
                name: 'Display Group 1',
                relativeDesktopLocation: {
                    height: 1080,
                    width: 1920,
                    x: 0,
                    y: 0,
                },
            },
            displayGroupRelativeBounds: {
                height: 1080,
                width: 1920,
                x: 0,
                y: 0,
            },
            desktopRelativeBounds: {
                height: 1080,
                width: 1920,
                x: 0,
                y: 0,
            },
            screenRectangles: [
                {
                    height: 1080,
                    width: 1920,
                    x: 0,
                    y: 0,
                },
            ],
            screens: [
                {
                    relativeDesktopLocation: {
                        height: 1080,
                        width: 1920,
                        x: 0,
                        y: 0,
                    },
                    relativeGroupLocation: {
                        height: 1080,
                        width: 1920,
                        x: 0,
                        y: 0,
                    },
                    displayControlState: 0,
                    isDisplayManagementConfigured: false,
                    isDisplayConnected: false,
                    id: 0,
                },
            ],
            wallStorageDirectory: `C:\\ProgramData\\WallControl 10\\${wallInfo.wallName}_${wallInfo.wallId}`,
            configLastUpdated: '2023-08-01T11:59:50.3481217-07:00',
            configState: 0,
            validationFailures: [],
            wallConfigType: 2,
            operationalState: 3,
            isBlueprintWall: false,
            wallIconName: 'Grid',
            wallColourName: 'Light Blue',
            displayControlSettings: {
                powerOnAtStartup: false,
                powerOffAtShutdown: false,
            },
            layoutSettings: {
                openLayoutOnStartup: 0,
                specifiedLayoutId: '00000000-0000-0000-0000-000000000000',
            },
        };
        return wallData;
    }
    makeId() {
        return `${this.makeSubId(8)}-${this.makeSubId(4)}-${this.makeSubId(4)}-${this.makeSubId(4)}-${this.makeSubId(12)}`;
    }
    makeSubId(length) {
        let result = '';
        const characters = 'abcdef0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter++;
        }
        return result;
    }
    createLayout(id, name) {
        return {
            layoutId: id,
            layoutName: name,
            isDirty: false,
            isLocalLayout: false,
            clientWallInstanceId: '00000000-0000-0000-0000-000000000000',
            templateInformation: {
                rows: 2,
                columns: 2,
                cells: [
                    {
                        row: 0,
                        column: 0,
                        rowSpan: 1,
                        columnSpan: 1,
                    },
                    {
                        row: 0,
                        column: 1,
                        rowSpan: 1,
                        columnSpan: 1,
                    },
                    {
                        row: 1,
                        column: 0,
                        rowSpan: 1,
                        columnSpan: 1,
                    },
                    {
                        row: 1,
                        column: 1,
                        rowSpan: 1,
                        columnSpan: 1,
                    },
                ],
            },
        };
    }
    createServerInfo() {
        return {
            serialNumber: '00107403',
            dongleType: 4,
            isMultiWallSupported: true,
            serverTopology: {
                desktopBounds: {
                    height: 1080,
                    width: 3840,
                    x: 0,
                    y: 0,
                },
                displayGroups: [
                    {
                        id: this.makeId(),
                        name: 'Display Group 1',
                        relativeDesktopLocation: {
                            height: 1080,
                            width: 1920,
                            x: 0,
                            y: 0,
                        },
                    },
                    {
                        id: this.makeId(),
                        name: 'Display Group 2',
                        relativeDesktopLocation: {
                            height: 1080,
                            width: 1920,
                            x: 1920,
                            y: 0,
                        },
                    },
                ],
                screens: [
                    {
                        relativeDesktopLocation: {
                            height: 1080,
                            width: 1920,
                            x: 0,
                            y: 0,
                        },
                        relativeGroupLocation: {
                            height: 1080,
                            width: 1920,
                            x: 0,
                            y: 0,
                        },
                        displayControlState: 0,
                        isDisplayManagementConfigured: false,
                        isDisplayConnected: false,
                        id: 0,
                    },
                    {
                        relativeDesktopLocation: {
                            height: 1080,
                            width: 1920,
                            x: 1920,
                            y: 0,
                        },
                        relativeGroupLocation: {
                            height: 1080,
                            width: 1920,
                            x: 0,
                            y: 0,
                        },
                        displayControlState: 0,
                        isDisplayManagementConfigured: false,
                        isDisplayConnected: false,
                        id: 1,
                    },
                ],
                walls: this.videoWalls,
            },
            serverApplicationVersion: '1.12.8',
            diagnosticSuitePort: 8000,
        };
    }
}
Datapath.emulatorType = 'httpRequestEmulator';
Datapath.key = '-NbZqHJuBv5WDqxPdweG';
